module.exports = __webpack_public_path__ + "img/control-processor-4.83f23fb1.svg";